import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { fromCreateJob } from '../../store';

@Injectable({
  providedIn: 'root',
})
export class JobEditResolver {
  constructor(private store: Store<{}>) {}
  resolve(): Observable<void> | void {
    this.store.dispatch(fromCreateJob({ fromCreateJob: 'create' }));
  }
}
